import type {
  Deployment,
  DeploymentsResponse,
} from "@/features/deployment-selection/model/deployment";
import { platformHttpClient } from "@/shared/api/platform-http-client";

export const DEPLOYMENTS_QUERY_KEY = ["deployments"] as const;

export async function fetchDeployments(): Promise<readonly Deployment[]> {
  const response = await platformHttpClient.get<DeploymentsResponse>("/v1/deployments");
  return response.deployments;
}
